import { ARSTActionSetTlfViewMode, ArsTableState } from "../interface";

/**
 * Updates the active TLF view mode.
 *
 * @param state - Current ARS table state
 * @param action - TLF view mode update action
 * @returns Updated ARS table state
 */
export const arst_setTlfViewMode = <T>(
  state: ArsTableState<T>,
  action: ARSTActionSetTlfViewMode,
): ArsTableState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    tlfViewMode: action.tlfViewMode,
  },
});
